import { useCallback, useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { isHtmlEmpty } from "utils/htmlContent";
import "./rich-text-editor.css";

/**
 * Éditeur WYSIWYG (Quill) compatible antd `Form.Item` :
 * reçoit `value` / `onChange` et conserve la mise en forme collée
 * (gras, italique, couleurs, listes, titres, sauts de ligne...).
 */
const RichTextEditor = ({
  value = "",
  onChange,
  placeholder,
  height = 220,
  readOnly = false,
}) => {
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: [] }],
        ["blockquote", "code-block", "link"],
        ["clean"],
      ],
      // matchVisual: false => pas de <p><br></p> parasites lors d'un collage
      clipboard: { matchVisual: false },
    }),
    []
  );

  const formats = useMemo(
    () => [
      "header",
      "bold",
      "italic",
      "underline",
      "strike",
      "color",
      "background",
      "list",
      "bullet",
      "indent",
      "align",
      "blockquote",
      "code-block",
      "link",
      "script",
    ],
    []
  );

  const handleChange = useCallback(
    (html) => {
      if (!onChange) return;
      // Quill renvoie "<p><br></p>" quand l'éditeur est vide
      onChange(isHtmlEmpty(html) ? "" : html);
    },
    [onChange]
  );

  return (
    <div className="rich-text-editor" style={{ "--rte-height": `${height}px` }}>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        readOnly={readOnly}
      />
    </div>
  );
};

export default RichTextEditor;
